import {Organization} from 'orgs/OrganizationConstants';
import EntityStore from 'stores/EntityStore';

function getCurrentUserOrganizations(): Array<Organization> {
  const currentUser = EntityStore.currentUser();
  return currentUser && currentUser.organizations ? currentUser.organizations : [];
}

export function hasAnyOrgsWithDisablePersonalOwnables(): boolean {
  const organizations = getCurrentUserOrganizations();
  return (
    organizations.length > 0 && organizations.some((organization) => organization.disablePersonalOwnables)
  );
}

export function hasAllOrgsWithDisablePersonalOwnables(): boolean {
  const organizations = getCurrentUserOrganizations();
  return (
    organizations.length > 0 && organizations.every((organization) => organization.disablePersonalOwnables)
  );
}
